<template>
  <a-drawer
    :visible="cfg.visible"
    :closable="cfg.closable"
    :destroy-on-close="cfg.destroyOnClose === undefined ? true : cfg.destroyOnClose"
    :mask="cfg.mask"
    :mask-closable="cfg.maskClosable"
    :title="cfg.title"
    :width="cfg.width"
    @close="handleClose"
  >
    <div
      v-if="cfg.waiting"
      class="text-center"
    >
      <a-spin />
    </div>
    <div
      v-else-if="cfg.errorText"
      class="text-center"
    >
      <span class="error-text">{{ cfg.errorText }}</span>
    </div>
    <template v-else>
      <template v-if="$slots.default">
        <slot />
      </template>
    </template>
  </a-drawer>
</template>

<script>
export default {
  name: 'Drawerx',
  props: {
    cfg: {
      type: Object,
      default: () => ({})
    }
  },
  mounted () {
    window.addEventListener('keydown', this.handleEsc)
  },
  beforeDestroy () {
    window.removeEventListener('keydown', this.handleEsc)
  },
  methods: {
    handleClose () {
      this.$emit('close')
      this.cfg.visible = false
    },
    handleEsc (e) {
      if (e.key === 'Esc' || e.key === 'Escape') {
        this.$emit('close')
        this.cfg.visible = false
      }
    }
  }
}
</script>

<style scoped>

</style>
